export const DESKTOP_BREAKPOINTS = {
    '809': 4,
    '704': 3,
    '0': 3
};

export const MOBILE_BREAKPOINTS = {
    '767': 2.6,
    '0': 2.6
};
